import type { JSX } from 'react';
import type { ITpoFlexGradingData } from '@common/validation/customControls/tpoFlex/tpoFlexGradingSchema';
import { FormGroupRead } from '@frontend/components/pages/customControls/utils/v1/FormGroupRead';
import { getSelectedLanguage } from '@frontend/translate';
import { useProcessActivityReadContext } from '@frontend/utils/hooks/useProcessActivityContext';

export function TpoFlexGradingRead(): JSX.Element {
    const { processActivity } = useProcessActivityReadContext<ITpoFlexGradingData>();

    return (
        <FormGroupRead
            label={getSelectedLanguage().common.remark}
            value={processActivity.customControlData.grading}
        />
    );
}
